import { FC } from 'react';
import { Select } from 'antd';
import { IProps } from './type';

const SMailSelector: FC<IProps> = (props) => {
  return (
    <Select
      value={props.value}
      defaultValue={props.value}
      placeholder={props.placeholder}
      mode="multiple"
      optionFilterProp={props.optionFilterProp}
      className={props.className}
      options={props.options}
      onChange={props.onChange}
    />
  );
};

export default SMailSelector;
